import * as React from 'react';
import * as URL from "../../services/url";
import axios from 'axios';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export default function Catchmentassign(props) {
    const [facilities, setFacilities] = useState([])
    const [catchment, setCatchment] = useState([])
    const [selectedCatchment, setSelectedCatchment] = useState([])
    const [open, setOpen] = React.useState(false);
    const [nonLabsList, setNonLabsList] = useState([]);
    const [LabsList, setLabsList] = useState([]);
    const [selectedNonLab, setSelectedNonLab] = useState([]);
    const [selectedFacilities, setSelectedFacilities] = useState([]);
    const [LabsLatLong, setLabsLatLong] = React.useState([]);
    const { id, lat, long } = props

    let daysObj = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

    useEffect(() => {
        open && getstrddata()
    }, [open])

    async function getstrddata() {
        let reqBody = {
            "id": id,
        }
        try {

            const response1 = await axios.post(URL.getLabsNlab, reqBody);
            if (response1 && response1.status == 200) {
                setSelectedCatchment(response1.data.Data)
                let filtnlabs = response1.data.Data.map(r=>{
                    return {"facility":r.cathment_key}
                })
                setLabsList(filtnlabs)
                // console.log("nlabs", filtnlabs);
            }
        } catch (error) {
            toast.error(error)
            console.error('Error:', error);
        }

        // let reqBody1 = {
        //     "userlat": lat,
        //     "userlong": long
        // }
        // try {

        //     const response = await axios.post(URL.getnlabs, reqBody1);
        //     if (response && response.status == 200) {
        //         setCatchment(response.data.locations.map(({ facility_name, cathment_key }) => ({ facility_name, cathment_key })))
        //     }
        // } catch (error) {
        //     toast.error(error)
        //     console.error('Error:', error);
        // }
    }

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const searchFacility = async (e) => {
        setCatchment([])
        if (e && e.target) {
            let reqBody = {
                "usertxt": e.target.value,
            }
            try {
                const response = await axios.post(URL.getnlabs, reqBody);
                if (response && response.status == 200) {
                    setCatchment(response.data.locations.map(({ facility_name, cathment_key }) => ({ facility_name, cathment_key })))
                    // setFacilities(response.data.locations)
                }
            } catch (error) {
                toast.error(error)
                console.error('Error:', error);
            }
        }
    }

    const selectFacility = async (e, v, r) => {
        // setSelectedFacilities(v)   
        setSelectedCatchment(v)
        console.log(e, v, r);
        // let latlong = v.map((l)=>{
        //     if(l.latitude!=null && l.longitude!=null){
        //         return [l.latitude ,l.longitude]
        //     }
        // })
        // setLabsLatLong(latlong)
        // getnlabs()
        // console.log(latlong);

        if (r == "selectOption") {
            let newlabs = [...LabsList, { facility: '' }]
            newlabs[LabsList.length].facility = v[v.length - 1].cathment_key
            setLabsList(newlabs)
            console.log(newlabs);
        } else if (r == "removeOption" || r == 'clear') {
            let newid = v.map((m) => {
                return m.cathment_key
            })
            let newlabs = [...LabsList].filter((l) => {
                return newid.includes(l.facility)
            })
            setLabsList(newlabs)
            console.log(newlabs, newid);
        }
    }

    const handleFacChange = (event, index, id) => {
        console.log(event.target, index);
        let newlabs = [...LabsList]
        newlabs[index].assigned_days = event.target.value
        setLabsList(newlabs)
        console.log(newlabs);
    };

    const selectNonLab = async (e, v, r) => {
        setSelectedNonLab(v)


        if (r == "selectOption") {
            let newlabs = [...nonLabsList, { facility: '', assigned_days: [] }]
            newlabs[nonLabsList.length].facility = v[v.length - 1].cathment_key
            setNonLabsList(newlabs)
            console.log(newlabs,);
        } else if (r == "removeOption" || r == 'clear') {
            let newid = v.map((m) => {
                return m.cathment_key
            })
            let newlabs = [...nonLabsList].filter((l) => {
                return newid.includes(parseInt(l.facility))
            })
            setNonLabsList(newlabs)
            console.log(newlabs, newid, v);
        }
    }

    const handleNonFacChange = (event, index, id) => {
        console.log(event.target.value);
        let newlabs = [...nonLabsList]
        newlabs[index].assigned_days = event.target.value
        setNonLabsList(newlabs)
        console.log(newlabs);
    };

    const clearSelect = async () => {
        setFacilities([])
    }

    const clearNonFacSelect = async () => {
        setCatchment([])
    }

    async function getnlabs() {
        if (LabsLatLong.length > 0) {

            let reqBody = {
                "latlongarr": LabsLatLong,
            }
            try {
                const response = await axios.post(URL.getnlabs, reqBody);
                if (response && response.status == 200) {
                    setCatchment(response.data.locations)
                }
            } catch (error) {
                toast.error(error)
                console.error('Error:', error);
            }
        }
    }

    const submitData = async () => {
        let request = {
            "genxid": id,
        }
        try {
            const response = await axios.post(URL.assignLabsNlab, { ...request, "nongenxids": LabsList });
            if (response && response.status == 200) {

                console.log(response);
            }

            handleClose()
        } catch (error) {
            toast.error(error)
            console.error('Error:', error);
        }
    }

    return (
        <React.Fragment>
            <Button onClick={() => handleOpen()} class="assignbtn">Assign</Button>
            <Modal
                className='FacModal'
                open={open}
                onClose={() => handleClose()}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box sx={{ ...style, width: "50vw", height: "80vh", overflowX: 'auto' }}>
                    <div className='textAlignEnd'>
                        <CloseOutlinedIcon onClick={() => handleClose()} className='mapSectCloseIcon'></CloseOutlinedIcon>
                    </div>
                    <Grid container spacing={2} className='mt-10px main-containerGrid'>

                        <Grid item xs={12}>
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                options={catchment}
                                multiple
                                filterSelectedOptions
                                value={selectedCatchment}
                                getOptionLabel={(option) => option.facility_name}
                                sx={{ width: 300 }}
                                onInputChange={(e) => searchFacility(e)}
                                onChange={(e, v, r) => selectFacility(e, v, r)}
                                renderInput={(params) => <TextField {...params} label="Search Referring Facility Name" />}
                            />
                            <Grid container spacing={2} className='mt-10px'>
                                {selectedCatchment.map((fac, index) => (<React.Fragment key={index}>

                                    <Grid item xs={6}>
                                        <TextField id="standard-basic" variant="standard" disabled value={fac.facility_name} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        {/* <FormControl sx={{ m: 1, width: 270 }}>
                                    <InputLabel id="demo-multiple-name-label">Operational Days</InputLabel>
                                    <Select
                                        labelId="demo-multiple-name-label"
                                        id="demo-multiple-name"
                                        multiple
                                        value={LabsList[index].assigned_days}
                                        onChange={(e)=>handleFacChange(e,index,fac.dno_id)}
                                        input={<OutlinedInput label="Operational Days" />}
                                        label="Operational Days"
                                        className='daysSelect'
                                        MenuProps={MenuProps}
                                    >
                                        {daysObj.map((name) => (
                                            <MenuItem
                                                key={name}
                                                value={name}
                                            >
                                                {name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    </FormControl> */}
                                    </Grid>
                                </React.Fragment>))}
                            </Grid>
                        </Grid>

                        {/* <Grid item xs={6}>
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                options={catchment}
                                multiple
                                getOptionLabel={(option) => option.facility_name}
                                value={selectedNonLab}
                                onChange={(e,v,r)=>selectNonLab(e,v,r)}
                                renderInput={(params) => <TextField {...params} label="Select catchments" />}
                            />
                            <Grid container spacing={2} className='mt-10px'>
                                {selectedNonLab.map((nonFac,index)=>
                                <React.Fragment>
                                <Grid item xs={6}>
                                    <TextField id="standard-basic" value={nonFac.facility_name} variant="standard" disabled />

                                </Grid>
                                <Grid item xs={6}>
                                <FormControl sx={{ m: 1, width: 270 }}>
                                    <InputLabel id="demo-multiple-name-label">Operational Days</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        className='daysSelect'
                                        multiple
                                        value={nonLabsList[index].assigned_days}
                                        onChange={(e)=>handleNonFacChange(e,index,nonFac.cathment_key)}
                                        input={<OutlinedInput label="Operational Days" />}
                                        label="Operational Days"
                                        MenuProps={MenuProps}
                                    >
                                        {daysObj.map((name) => (
                                            <MenuItem
                                                key={name}
                                                value={name}
                                            >
                                                {name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    </FormControl>
                                </Grid>
                                </React.Fragment>
                                )}
                            </Grid>
                        </Grid> */}



                    </Grid>

                    <Grid item xs={12} className='button-facility'>
                        <div>
                            <Button onClick={submitData} class='assignbtn'>Submit</Button>
                        </div>
                    </Grid>


                </Box>
            </Modal>
        </React.Fragment>
    )
}